<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="7" sm="9" md="10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search admin / manager" single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>
            <v-col cols="5" sm="3" md="2">
              <v-row class="justify-md-center" align="center">
                <AddAdmin>  </AddAdmin>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <EditAdmin :search="search" > </EditAdmin>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddAdmin from "./AddAdmin.vue";
import EditAdmin from "./EditAdmin.vue";

export default {
  components: {
    AddAdmin,
    EditAdmin,
  },
  data() {
    return {
      search: "",
    };
  },
};
</script>
